package one.healthium.healthKit.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.components.AppButton
import one.healthium.ui.compose.components.AppButtonDefaults
import one.healthium.ui.compose.theme.AppTheme
import org.jetbrains.compose.resources.painterResource

interface HealthKitConnectBannerContract {
    fun onSkipClicked()
}

@Composable
fun HealthKitConnectBanner(
    modifier: Modifier = Modifier,
    contract: HealthKitConnectBannerContract,
) {
    Surface(
        modifier = modifier
            .padding(horizontal = 12.dp)
            .fillMaxWidth(),
        color = AppTheme.healthKitBannerStyle.containerColorOrDefault,
        shape = AppTheme.healthKitBannerStyle.shapeOrDefault,
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(top = 24.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Image(
                painter = painterResource(ConnectBannerHelper.healthKitIcon),
                contentDescription = null,
                modifier = Modifier.size(40.dp),
            )
            Spacer(modifier = Modifier.height(12.dp))

            Text(
                text = "${ConnectBannerHelper.healthKitName} connection",
                style = AppTheme.textStyles.secondary_17_500,
                color = AppTheme.healthKitBannerStyle.contentColorOrDefault,
            )

            Spacer(modifier = Modifier.height(12.dp))

            Text(
                modifier = Modifier.padding(horizontal = 24.dp),
                text = "Sync your weight, diet, sleep and other data to track your progress with the app.",
                style = AppTheme.textStyles.secondary_14_400,
                color = AppTheme.healthKitBannerStyle.contentColorOrDefault,
                textAlign = TextAlign.Center,
            )
            Row(
                modifier = Modifier.padding(top = 33.dp, bottom = 24.dp),
                horizontalArrangement = Arrangement.Center
            ) {
                ConnectFlowContainer(action = ConnectFlowAction.CONNECT) {
                    AppButton(
                        onClick = { it.invoke() },
                        modifier = Modifier.height(45.dp),
                        colors = AppTheme.healthKitBannerStyle.actionButtonStyle,
                        elevation = AppButtonDefaults.elevatedButtonElevationZero,
                    ) {
                        Text("Continue")
                    }
                }
            }
        }
    }
}
